export const SMS_SENT = 'SMS_SENT'
export const CODE_VALIDATED = 'CODE_VALIDATED'
export const SET_AUTH_ERROR = 'SET_AUTH_ERROR'
